/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng-recaptcha/recaptcha/recaptcha.component';
import * as i2 from 'ng-recaptcha/recaptcha/recaptcha-loader.service';
import * as i3 from 'ng-recaptcha/recaptcha/recaptcha-settings';
const styles_RecaptchaComponent:any[] = ([] as any[]);
export const RenderType_RecaptchaComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_RecaptchaComponent,data:{}});
export function View_RecaptchaComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,([] as any[]),(null as any),(null as any));
}
export function View_RecaptchaComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'re-captcha',
      ([] as any[]),[[1,'id',0]],(null as any),(null as any),View_RecaptchaComponent_0,
      RenderType_RecaptchaComponent)),i0.ɵdid(1,4374528,(null as any),0,i1.RecaptchaComponent,
      [i0.ElementRef,i2.RecaptchaLoaderService,i0.NgZone,[2,i3.RECAPTCHA_SETTINGS]],
      (null as any),(null as any))],(null as any),(_ck,_v) => {
    const currVal_0:any = i0.ɵnov(_v,1).id;
    _ck(_v,0,0,currVal_0);
  });
}
export const RecaptchaComponentNgFactory:i0.ComponentFactory<i1.RecaptchaComponent> = i0.ɵccf('re-captcha',
    i1.RecaptchaComponent,View_RecaptchaComponent_Host_0,{id:'id',siteKey:'siteKey',
        theme:'theme',type:'type',size:'size',tabIndex:'tabIndex',badge:'badge'},{resolved:'resolved'},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9ub2RlX21vZHVsZXMvbmctcmVjYXB0Y2hhL3JlY2FwdGNoYS9yZWNhcHRjaGEuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjNTYwNTk5NjQ0L3NyYy9ub2RlX21vZHVsZXMvbmctcmVjYXB0Y2hhL3JlY2FwdGNoYS9yZWNhcHRjaGEuY29tcG9uZW50LmQudHMiLCJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzU2MDU5OTY0NC9zcmMvbm9kZV9tb2R1bGVzL25nLXJlY2FwdGNoYS9yZWNhcHRjaGEvcmVjYXB0Y2hhLmNvbXBvbmVudC5kLnRzLlJlY2FwdGNoYUNvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxyZS1jYXB0Y2hhPjwvcmUtY2FwdGNoYT4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7bUNBQUEsVUFBQTtNQUFBO01BQUE7SUFBQTtJQUFBLFdBQUEsU0FBQTs7Ozs7OyJ9



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/$$_gendir/~/ng-recaptcha/recaptcha/recaptcha.component.ngfactory.ts